import { ESLintUtils } from '@typescript-eslint/utils'

export const createRule = ESLintUtils.RuleCreator(
  (name) => `https://eslint.nht.io/api/@nhtio/eslint-config/rules/variables/${name}.html`
)
